import {FC, useEffect, useState} from "react";
import {createPortal} from "react-dom";
import useDelayUnmount from "../hooks/useDelayUnmount";

interface IProps {
  children: React.ReactNode;
  isOpenSideBar: boolean;
}

export const SidebarCardContainer: FC<IProps> = ({children, isOpenSideBar}) => {
  const [isMounted, setIsMounted] = useState(false);
  const waitOpen = useDelayUnmount(isOpenSideBar, 200, setIsMounted);

  const mountedStyle = {
    opacity: 1,
    transition: "all 300ms ease",
    left: 0,
  };
  const unmountedStyle = {
    opacity: 0,
    transition: "all 200ms ease",
    left: -800,
  };

  useEffect(() => {
    const setTime = setTimeout(() => {
      if (!waitOpen) setIsMounted(false);
    }, 600);
    return () => clearTimeout(setTime);
  }, [waitOpen]);

  const sidebarContent = (
    <div
      style={
        waitOpen
          ? {
              ...mountedStyle,
              position: "absolute",
              top: "12px",
              bottom: "12px",
              zIndex: 50,
            }
          : {
              ...unmountedStyle,
              position: "absolute",
              top: "12px",
              bottom: "12px",
              zIndex: 50,
            }
      }
    >
      {children}
    </div>
  );
  return (
    <>
      {(isOpenSideBar || isMounted) &&
        createPortal(sidebarContent, document.body)}
    </>
  );
};
